/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Email_LabelInputs */

const en_ticket_email_label = /** @type {(inputs: Ticket_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const ja_ticket_email_label = /** @type {(inputs: Ticket_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール:`)
};

const fr_ticket_email_label = /** @type {(inputs: Ticket_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail :`)
};

const de_ticket_email_label = /** @type {(inputs: Ticket_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail:`)
};

/**
* | output |
* | --- |
* | "Email:" |
*
* @param {Ticket_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_email_label = /** @type {((inputs?: Ticket_Email_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Email_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_email_label(inputs)
	if (locale === "ja") return ja_ticket_email_label(inputs)
	if (locale === "fr") return fr_ticket_email_label(inputs)
	return de_ticket_email_label(inputs)
});